import http from "./http";

// 友情链接 /system/dict/data/list/open
function friendlyLink(dictType = "blogroll", pageNum = 1, pageSize = 10, orderByColumn = "dictSort", isAsc = "asc") {
    let url = `/api/system/dict/data/list/open`;
    const formdata = new FormData();
    formdata.append("dictType", dictType);
    formdata.append("pageNum", pageNum);
    formdata.append("pageSize", pageSize);
    formdata.append("orderByColumn", orderByColumn);
    formdata.append("isAsc", isAsc);

    return http.post(url, formdata)
}


export {
    friendlyLink
}
